import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, map, switchMap, tap } from 'rxjs/operators'
import { of } from 'rxjs'
import { ActionFailed, Toaster } from '@tokeet-frontend/tv3-platform'
import { EntityAttributesService } from './service'
import {
  LoadCustomAttributes,
  LoadCustomAttributesByEntityType,
  LoadCustomAttributesByEntityTypeComplete,
  AddCustomAttribute,
  LoadCustomAttributesComplete,
  AddCustomAttributeComplete,
} from './actions'

@Injectable()
export class AttributeEffects {
  all$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadCustomAttributes),
      switchMap(() =>
        this.service.getAllAttributes().pipe(
          map((items) => LoadCustomAttributesComplete({ items })),
          catchError((error) => of(ActionFailed({ error })))
        )
      )
    )
  )

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadCustomAttributesByEntityType),
      switchMap(({ entityType, entityId }) =>
        this.service.getAttributes(entityType, entityId).pipe(
          map((item) => LoadCustomAttributesByEntityTypeComplete({ item })),
          catchError((error) => of(ActionFailed({ error })))
        )
      )
    )
  )

  create$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AddCustomAttribute),
      switchMap(({ entityType, entityId, payload }) => {
        return this.service.create(entityType, entityId, payload).pipe(
          map((item) => AddCustomAttributeComplete({ item })),
          tap(() => this.toaster.success($localize`Attributes saved successfully.`)),
          catchError((error) => of(ActionFailed({ error })))
        )
      })
    )
  )

  constructor(private actions$: Actions, private service: EntityAttributesService, private toaster: Toaster) {}
}
